module.exports = __webpack_public_path__ + "static/media/chickenbiryani.074d6dfa.jpg";